module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/italy.f26a0678.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/italy.png
// module id = 2789
// module chunks = 11